import { environmentMapper, ENVIRONMENTS } from './environments';

export const getWrapperEnv = environmentMapper({
  'https://localhost.corp.adobe.com:8080': ENVIRONMENTS.local,
  'https://auth-light-sample.identity-stage.adobe.com': ENVIRONMENTS.stage,
  'https://auth-light-sample.identity-prestage.adobe.com':
    ENVIRONMENTS.prestage,
  'https://auth-light-sample.identity-preprod.adobe.com': ENVIRONMENTS.preprod,
});

// The iframe-side prestage CDN origin resolves to ENVIRONMENTS.stage so the prestage
// iframe app talks to STAGE APIs (prestage is stage-flavored). The consumer-side
// getWrapperEnv above resolves to prestage so the wrapper loads the iframe from the
// prestage CDN.
export const getAppEnv = environmentMapper({
  'https://localhost.corp.adobe.com:25000': ENVIRONMENTS.local,
  'https://auth-light.identity-stage.adobe.com': ENVIRONMENTS.stage,
  'https://auth-light.identity-prestage.adobe.com': ENVIRONMENTS.stage,
  'https://auth-light.identity-preprod.adobe.com': ENVIRONMENTS.prod,
});
